
import { sha256 } from 'js-sha256';
import { Base64 } from 'js-base64';

// Génère un code_verifier aléatoire (43 à 128 caractères)
export function generateCodeVerifier(length = 128) {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        result += charset[randomIndex];
    }
    return result;
}

// Convertit le hash en Base64 URL-safe
export function base64UrlEncode(str: string): string {
    return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// Génère le code_challenge à partir du code_verifier
export function generateCodeChallenge(codeVerifier: string): string {
    const hashed = sha256.arrayBuffer(codeVerifier);
    const base64encoded = Base64.encode(String.fromCharCode(...new Uint8Array(hashed)));
    return base64UrlEncode(base64encoded);
}